import { ICountry } from '../../models/country'

export enum SignInTypeKeys {
  SET_SIGN_IN_USERNAME = 'SET_SIGN_IN_USERNAME',
  SET_SIGN_IN_PASSWORD = 'SET_SIGN_IN_PASSWORD',
  SET_SIGN_IN_CALLING_CODE = 'SET_SIGN_IN_CALLING_CODE',
  SET_SIGN_IN_COUNTRY = 'SET_SIGN_IN_COUNTRY',
  SIGN_IN = 'SIGN_IN',
  SIGNING_IN = 'SIGNING_IN',
  SIGN_IN_SUCCESSFUL = 'SIGN_IN_SUCCESSFUL',
  SIGN_IN_FAILED = 'SIGN_IN_FAILED',
  SIGN_OUT = 'SIGN_OUT',
  SIGN_OUT_WITHOUT_USER_CREDENTIALS = 'SIGN_OUT_WITHOUT_USER_CREDENTIALS',
  CLEAR_SIGN_IN_FIELDS = 'CLEAR_SIGN_IN_FIELDS',
  SIGN_IN_NEW_PASSWORD_REQUIRED = 'SIGN_IN_NEW_PASSWORD_REQUIRED',
  CLEAR_SIGN_IN_ERROR = 'CLEAR_SIGN_IN_ERROR'
}

export interface ISetSignInUsernameAction {
  type: typeof SignInTypeKeys.SET_SIGN_IN_USERNAME
  payload: string
  [extraProps: string]: unknown
}

export interface ISetSignInPasswordAction {
  type: typeof SignInTypeKeys.SET_SIGN_IN_PASSWORD
  payload: string
  [extraProps: string]: unknown
}

export interface ISetSignInCallingCodeAction {
  type: typeof SignInTypeKeys.SET_SIGN_IN_CALLING_CODE
  payload: string
}

export interface ISetSignInCountryAction {
  type: typeof SignInTypeKeys.SET_SIGN_IN_COUNTRY
  payload: ICountry
}

export interface ISignInAction {
  type: typeof SignInTypeKeys.SIGN_IN
  [extraProps: string]: unknown
}

export interface ISetIsSigningInAction {
  type: typeof SignInTypeKeys.SIGNING_IN
  [extraProps: string]: unknown
}

export interface ISignInSuccessfulAction {
  type: typeof SignInTypeKeys.SIGN_IN_SUCCESSFUL
  [extraProps: string]: unknown
}

export interface ISignInFailedAction {
  type: typeof SignInTypeKeys.SIGN_IN_FAILED
  payload: any
  [extraProps: string]: unknown
}

export interface ISignOutAction {
  type: typeof SignInTypeKeys.SIGN_OUT
  [extraProps: string]: unknown
}

export interface ISignOutWithourUserCredentialsAction {
  type: typeof SignInTypeKeys.SIGN_OUT_WITHOUT_USER_CREDENTIALS
  [extraProps: string]: unknown
}

export interface IClearSignInFieldsAction {
  type: typeof SignInTypeKeys.CLEAR_SIGN_IN_FIELDS
  [extraProps: string]: unknown
}

export interface ISignInNewPasswordRequiredAction {
  type: typeof SignInTypeKeys.SIGN_IN_NEW_PASSWORD_REQUIRED
  payload: boolean
  [extraProps: string]: unknown
}

export interface IClearSignInErrorAction {
  type: typeof SignInTypeKeys.CLEAR_SIGN_IN_ERROR
  [extraProps: string]: unknown
}

export type SignInActionTypes =
  | ISetSignInUsernameAction
  | ISetSignInPasswordAction
  | ISetSignInCallingCodeAction
  | ISetSignInCountryAction
  | ISignInAction
  | ISetIsSigningInAction
  | ISignInSuccessfulAction
  | ISignInFailedAction
  | ISignOutAction
  | ISignOutWithourUserCredentialsAction
  | IClearSignInFieldsAction
  | ISignInNewPasswordRequiredAction
  | IClearSignInErrorAction
